export const hasReservationGlobalSearch = (value) =>
  String(value ?? "").trim().length > 0;

export const getReservationRangeParam = ({
  searchTerm,
  range,
  isArchive = false,
} = {}) => {
  if (isArchive || hasReservationGlobalSearch(searchTerm)) {
    return undefined;
  }

  const normalizedRange = String(range ?? "").trim();

  return normalizedRange && normalizedRange !== "all"
    ? normalizedRange
    : undefined;
};
